import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PartnerSnapshotBusinessSnapshot from "../../../Components/PartnerSideDashboard/PartnerSideDefaultDashboard/PartnerSideBusinessSnapshot";
import PartnerSideNewClientStatus from "../../../Components/PartnerSideDashboard/PartnerSideDefaultDashboard/PartnerSideClientStatus";
import PartnerSideTopActiveClientTable from "../../../Components/PartnerSideDashboard/PartnerSideDefaultDashboard/PartnerSideTopActiveClientTable";
import PartnerSideTopInActiveClientTable from "../../../Components/PartnerSideDashboard/PartnerSideDefaultDashboard/ParterSideTopInActiveClientTable";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import { useEffect } from "react";
import axios from "axios";
import { partner_Api } from "../../../Configuration/Partner_URL";
import { useState } from "react";
import { toast } from "react-toastify";
import { decryptData } from "../../../CommonMethhods/CommonMethods";



function PartnerSideDefaultDashboard() {
  const storeToken = localStorage.getItem("ssoToken");
  const [partnerId, setPartnerId] = useState("");
  const partnerFlag = localStorage.getItem("partnerFlag");
  const partnerMobileNo = localStorage.getItem("partnerMobileNo");
  const partnerSsoToken = localStorage.getItem("partnerSsoToken");

  if(storeToken == null){
    window.location.replace("/");
  }

  const PartnerMobile= localStorage.getItem("PartnerMobile");

  const getPartnerId = async () => {
    try {
      const getStatus = await axios.get(
        `${partner_Api.GET_PID_DETAILS}?mobile=${partnerFlag == "true" ? partnerMobileNo: PartnerMobile}`,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerFlag == "true" ? partnerSsoToken : storeToken}`
          },
        }
        
      );
      
      const res = decryptData(getStatus?.data);
      let respData = JSON.parse(res);
      const partnerId=respData?.data?.info?.partnerCode;
      if(respData?.status === 0){
        setPartnerId(respData?.data?.info);
      }else{
        toast.error(respData?.message);
      }
      localStorage.setItem("partnerId", partnerId);
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };

  useEffect(()=>{
    getPartnerId();
  }, []);
  
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="default"
        role="tabpanel"
        aria-labelledby="default-tab"
      >
        {/* Buisness Snapshot */}
        <PartnerSnapshotBusinessSnapshot 
        // partnerId={partnerId}
        />
        {/* Business snapshot */}

        <PartnerSideNewClientStatus
        // partnerId={partnerId}
          getClientStatus={DASHBOARD_DEFAULT.ClientStatus_URL}
        />
        {/* Client Status End */}

        {/* Top active inactive */}
        <div className="row">
          <div className="col-md-12 col-lg-6 gap-20">
            <PartnerSideTopActiveClientTable
        // partnerId={partnerId}
              getActiveClientInfo={DASHBOARD_DEFAULT.TopActiveClient_URL} />
          </div>
          <div className="col-md-12 col-lg-6">
            <PartnerSideTopInActiveClientTable
        // partnerId={partnerId}
              getInActiveClientInfo={DASHBOARD_DEFAULT.TopInActiveClient_URL} />
          </div>
        </div>
        {/* Top active inactive end*/}
        
      </div>
    </>
  );
}

export default PartnerSideDefaultDashboard;
